import { IFlowStepSequence } from "./IFlowStepSequence";
import { FlowStepSequence } from "./FlowStepSequence";
import { FlowStepOutputInstructions } from "./FlowStepOutputInstructions";
import { FlowStepSequenceType } from "./FlowStepSequenceType";
import { DataUtilities } from "../../Common/DataUtilities";
import { FlowConstants } from "../Utilities/FlowConstants";
import { IDataDefinition } from "../../Common/Data/Definitions/IDataDefinition";

export class CandidateSequence implements IFlowStepSequence {
    readonly sequenceType = FlowStepSequenceType.PATH_CANDIDATE;

    _id: string = DataUtilities.generateUniqueId();
    x: number;
    y: number;
    name?: string | undefined;
    instruction: FlowStepOutputInstructions;

    constructor(instruction: FlowStepOutputInstructions) {
        this.instruction = instruction;
        this.x = instruction.candidateStackX;
        this.y = instruction.candidateStackY;
    }

    get desiredX(): number {
        return this.instruction.candidateStackX!;
    }

    set desiredX(value: number) {
        this.instruction.candidateStackX = value;
    }

    get desiredY(): number {
        return this.instruction.candidateStackY!;
    }

    set desiredY(value: number) {
        this.instruction.candidateStackY = value;
    }

    getElementId(): string {
        return this._id;
    }

    createSequence(): FlowStepSequence {
        let s = new FlowStepSequence();
        s.desiredX = this.x;
        s.desiredY = this.y + FlowConstants.TITLE_AREA_HEIGHT + 15;
        s._id = this._id;
        return s;
    }

    reset(): void {
        this.x = this.desiredX;
        this.y = this.desiredY;
    }

    getAddedData(): IDataDefinition[] | undefined {
        return undefined;
    }
}
